import React from 'react';
import { DegreeCard } from './DegreeCard';
import { degreeCategories } from '../data/degrees';
export function DegreeCategoryGrid() {
  return <section className="py-16 bg-light" data-id="element-165" data-mp="110qc7x7sks21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166" data-mp="w2otjdea2ur3">
        <div className="text-center mb-12" data-id="element-167" data-mp="w389wpoa5b30">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" style={{
          color: "#5B4EA8"
        }} data-id="element-168" data-mp="s1v4ggp3n9wm">
            Explore Popular Degree Categories
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-169" data-mp="1otqgw1s4jwlp">
            Browse programs by field of study to find the right path for your
            career goals. All our partner schools are fully accredited.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-170" data-mp="1b10rdnde09ju">
          {degreeCategories.map(category => <DegreeCard key={category.id} category={category} data-id="element-171" data-mp="27j5axc9e7lgl" />)}
        </div>
      </div>
    </section>;
}